import { render, staticRenderFns } from "./LiveChatMp4V2JsonMode.vue?vue&type=template&id=a532c724&scoped=true&"
import script from "./LiveChatMp4V2JsonMode.vue?vue&type=script&lang=js&"
export * from "./LiveChatMp4V2JsonMode.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatMp4V2JsonMode.vue?vue&type=style&index=0&id=a532c724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a532c724",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSpacer,VTextField,VTooltip})
